<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="addPaIndexGroup" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="名称" prop="PaIndexGroup.name">
            <el-input class="input-item" v-model="formData.PaIndexGroup.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排序" prop="PaIndexGroup.sort">
            <el-input-number class="input-item" v-model="formData.PaIndexGroup.sort"
              :clearable="true"
              placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="描述" prop="PaIndexGroup.detail">
            <el-input class="input-item" v-model="formData.PaIndexGroup.detail"
              :clearable="true" placeholder="描述"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="备注" prop="PaIndexGroup.remark">
            <el-input class="input-item" v-model="formData.PaIndexGroup.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col class="table-box gutter-bottom" :span="24">
          <el-table ref="paIndexModel" :data="addPaIndexGroup.PaIndexModel.impl.dataList" :size="defaultFormItemSize" @sort-change="addPaIndexGroup.PaIndexModel.impl.onSortChange"
            header-cell-class-name="table-header-gray" header-row-class-name="hideHeaderCheckBox"
            @select="handleRowClick" row-key="id" default-expand-all height="600px"
          >
            <el-table-column type="selection" width="55px"></el-table-column>
            <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="addPaIndexGroup.PaIndexModel.impl.getTableIndex" />
            <el-table-column label="名称" header-align="center" prop="name" width="250px">
            </el-table-column>
            <el-table-column label="参数" header-align="center" prop="paramVariable" width="400px">
              <template slot-scope="scope">
                <span v-if="scope.row.gcode!=='pa_work'">{{scope.row.paramVariable}}</span>
                <div v-if="scope.row.gcode==='pa_work'">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-tag>权重系数：<el-input-number size="mini" v-model="scope.row.pa_work.indexWeightValue" :precision="2" :step="0.01" :max="1" style="width: 100px"/></el-tag>
                    </el-col>
                    <el-col :span="12" v-if="scope.row.code==='work_lv_a_rate'">
                      <el-tag>满分线(%)：<el-input-number size="mini" v-model="scope.row.pa_work.fullScoreLine" style="width: 100px" :max="100"/></el-tag>
                    </el-col>
                    <el-col :span="12" v-if="scope.row.code==='work_lv_a_rate'">
                      <el-tag>扣分系数：<el-input-number size="mini" v-model="scope.row.pa_work.deductionFactor" style="width: 100px"/></el-tag>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="指标值" prop="indexValue" header-align="center" width="100px">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.indexValue" v-if="scope.row.type==='index'&&scope.row.gcode!=='pa_work'&&scope.row.verifyRule"/>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" header-align="center">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.remark" :disabled="scope.row.remark.indexOf('指标值为')>-1"/>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('AddPaIndexGroup:addPaIndexGroup:add')"
              @click="onAddClick()">
              新增
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<style>
.hideHeaderCheckBox .el-checkbox__input {
  display: none
}
</style>
<script>
/* eslint-disable-next-line */
import {findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaIndexModelController, PaIndexGroupController, DictionaryController } from '@/api';

export default {
  name: 'AddPaIndexGroup',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    pid: {
      default: undefined
    },
    type: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaIndexModel: {
          id: undefined,
          pid: this.pid,
          type: this.type,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false
        },
        PaIndexGroup: {
          id: undefined,
          pid: undefined,
          type: 'group',
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: 1,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'PaIndexGroup.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ]
      },
      addPaIndexGroup: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        PaIndexModel: {
          impl: new TableWidget(this.loadPaIndexModelWidgetData, this.loadPaIndexModelVerify, false, false, 'sort', 1)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (Array.isArray(row)) {
        row = column;
      }
      let lines = this.$refs.paIndexModel.selection;
      let dataList = this.addPaIndexGroup.PaIndexModel.impl.dataList;
      let isInSelection = row === column;
      let groupLines = [];
      for (let i = 0; i < lines.length; i++) {
        if (lines[i] === row) {
          isInSelection = !isInSelection;
        }
        if (lines[i].pid === 1) {
          groupLines.push(lines[i]);
        }
      }

      this.$refs.paIndexModel.toggleRowSelection(row, !isInSelection);

      for (let j = 0; j < dataList.length; j++) {
        // 设置子项
        if (row.pid === 1) {
          for (let i = 0; i < row.children.length; i++) {
            this.$refs.paIndexModel.toggleRowSelection(row.children[i], !isInSelection);
          }
        }
        // 选中父项
        if (!isInSelection && row.pid !== 1 && row.gcode === dataList[j].code) {
          this.$refs.paIndexModel.toggleRowSelection(dataList[j], true);
          break;
        }
      }

      // 清理没有选中子项的行
      for (let j = 0; j < groupLines.length; j++) {
        let hasSelection = false;
        for (let i = 0; i < lines.length; i++) {
          if (lines[i].pid !== 1 && lines[i].gcode === groupLines[j].code) {
            hasSelection = true;
          }
        }
        this.$refs.paIndexModel.toggleRowSelection(groupLines[j], hasSelection);
      }
    },
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 绩效指标模型数据获取函数，返回Promise
     */
    loadPaIndexModelWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params
      }
      return new Promise((resolve, reject) => {
        PaIndexModelController.list(this, params).then(res => {
          let dataList = res.data.dataList;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].type !== 'index') {
              // dataList[i].levelCodeDictMap.name = '';
              // dataList[i].detail = '';
            }
            if (dataList[i].gcode === 'pa_work') {
              dataList[i].pa_work = JSON.parse(dataList[i].detail);
            }
          }
          resolve({
            dataList: treeDataTranslate(dataList, 'id', 'pid'),
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 绩效指标模型数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaIndexModelVerify () {
      return true;
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDictByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 更新添加指标组
     */
    refreshAddPaIndexGroup (reloadData = false) {
      if (reloadData) {
        this.addPaIndexGroup.PaIndexModel.impl.refreshTable(true, 1);
      } else {
        this.addPaIndexGroup.PaIndexModel.impl.refreshTable();
      }
      if (!this.addPaIndexGroup.isInit) {
        // 初始化下拉数据
      }
      this.addPaIndexGroup.isInit = true;
    },
    /**
     * 新增
     */
    onAddClick () {
      this.$refs.addPaIndexGroup.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            typeDictMap: findItemFromList(this.addPaIndexGroup.type.impl.dropdownList, this.formData.PaIndexGroup.type, 'id'),
            ...this.formData.PaIndexGroup
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          paIndexGroupDto: {
            pid: this.pid,
            type: this.formData.PaIndexGroup.type,
            code: this.formData.PaIndexGroup.code,
            gcode: this.formData.PaIndexGroup.gcode,
            name: this.formData.PaIndexGroup.name,
            detail: this.formData.PaIndexGroup.detail,
            remark: this.formData.PaIndexGroup.remark,
            sort: this.formData.PaIndexGroup.sort,
            lines: []
          }
        };
        let lines = this.$refs.paIndexModel.selection;
        let paSalaryLines = [];
        let paWorkLines = [];

        for (let i = 0; i < lines.length; i++) {
          let line = lines[i];
          line.indexModelId = line.id;
          line.id = undefined;
          if (line.code === 'pa_salary') {
            line.lines = paSalaryLines;
            params.paIndexGroupDto.lines.push(line);
          }
          if (line.gcode === 'pa_salary') {
            if (line.verifyRule) {
              let verifyRule;
              // eslint-disable-next-line no-eval
              eval('verifyRule=' + line.verifyRule);
              if (!Array.isArray(verifyRule)) {
                verifyRule = [verifyRule];
              }
              for (let p = 0; p < verifyRule.length; p++) {
                let pattern = new RegExp(verifyRule[p].pattern);
                if (!pattern.test(line.indexValue)) {
                  this.$message.error('[' + line.name + ']' + verifyRule[p].message);
                  return;
                }
              }
            }
            paSalaryLines.push(line);
          }
          if (line.code === 'pa_work') {
            line.lines = paWorkLines;
            params.paIndexGroupDto.lines.push(line);
          }
          if (line.gcode === 'pa_work') {
            line.detail = line.pa_work;
            paWorkLines.push(line);
          }
        }
        let indexWeightValueSum = 0;
        for (let i = 0; i < paWorkLines.length; i++) {
          let line = paWorkLines[i];
          console.log('indexWeightValue>>>>>>>>>>>>', line.pa_work.indexWeightValue);
          indexWeightValueSum += line.pa_work.indexWeightValue;
          console.log('indexWeightValueSum>>>>>>>>>>>>', indexWeightValueSum);
        }
        console.log('>>>>>>>>>>>>', paWorkLines.length);
        console.log('>>>>>>>>>>>>', indexWeightValueSum);
        console.log('>>>>>>>>>>>>', parseFloat(indexWeightValueSum).toFixed(2));
        if (paWorkLines.length > 0 && parseFloat(indexWeightValueSum).toFixed(2) !== parseFloat(1).toFixed(2)) {
          this.$message.error('所选权重之和应为1');
          return;
        }

        PaIndexGroupController.add(this, params).then(res => {
          this.$message.success('新增成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaIndexModel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false
        },
        PaIndexGroup: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshAddPaIndexGroup();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaIndexGroup = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
